import { Box, Card, CardContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ApiFetchImage } from "utils/ApiCall";

export default function ResidentBanner({
  residentId,
  residentName,
  roomNumber,
  bed,
  showPhoto,
  onPhotoVisibilityChange,
}) {
  const [photo, setPhoto] = useState(null);
  const visiblePhoto = showPhoto ? photo : null;

  useEffect(() => {
    if (!showPhoto || !residentId || +residentId === 0) {
      setPhoto(null);
      return;
    }

    let isActive = true;
    setPhoto(null);

    ApiFetchImage(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_BASE_URL}/Residents/Photo/${residentId}`
    )
      .then((res) => {
        if (!isActive || !res) {
          if (isActive) {
            setPhoto(null);
          }
          return;
        }

        const reader = new FileReader();
        reader.onload = function () {
          if (isActive) {
            setPhoto(reader.result);
          }
        };
        reader.readAsDataURL(res);
      })
      .catch((error) => {
        console.error(error);
        if (isActive) {
          setPhoto(null);
        }
      });

    return () => {
      isActive = false;
    };
  }, [residentId, showPhoto]);

  useEffect(() => {
    onPhotoVisibilityChange?.(!!visiblePhoto);
  }, [onPhotoVisibilityChange, visiblePhoto]);

  return (
    <Card
      sx={{
        position: "relative",
        zIndex: 10,
        overflow: "visible",
        boxShadow: visiblePhoto
          ? "-.05rem 0.25rem .25rem .0625rem rgba(0, 0, 0, .35) !important"
          : ".125rem .25rem .25rem .0625rem rgba(0, 0, 0, .35) !important",
      }}
    >
      <CardContent
        sx={{
          padding: ".5rem .75rem .5rem .75rem !important",
          display: "block",
          borderRadius: ".5rem",
          backgroundColor: "#3e6281",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: "white !important",
            fontWeight: "bold",
            textTransform: "uppercase",
            width: "100%",
          }}
        >
          {residentName}
        </Typography>
        {visiblePhoto && (
          <Box
            component="div"
            sx={{
              position: "absolute",
              zIndex: 10,
              top: 0,
              right: 0,
              padding: ".75rem",
              backgroundColor: "#3e6281",
              borderRadius: "var(--borderRadius)",
              boxShadow:
                ".5rem .25rem .25rem .0625rem rgba(0, 0, 0, .35) !important",
            }}
          >
            <Box
              component="img"
              src={visiblePhoto}
              alt={`${residentName} profile`}
              sx={{
                float: "right",
                borderRadius: "var(--borderRadius) !important",
                backgroundColor: "#3e6281",
                width: "6.25rem",
                height: "6.25rem",
                objectFit: "contain",
              }}
            />
          </Box>
        )}
        <Box
          display="flex"
          flexWrap="nowrap"
          justifyContent={visiblePhoto ? "flex-start" : "flex-end"}
        >
          <Typography
            variant="subtitle2"
            sx={{
              color: "white !important",
              display: "inline",
              marginRight: ".5rem",
              fontWeight: "bold",
            }}
          >
            {roomNumber && `ROOM: ${roomNumber}`}
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              color: "white !important",
              display: "inline",
              fontWeight: "bold",
            }}
          >
            {bed && `BED: ${bed}`}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
